import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1817">
      <div className="dark" data-id="element-1818">
        <Hero data-id="element-1819" />
      </div>
      <WhyUs data-id="element-1820" />
      <Services data-id="element-1821" />
      <HowItWorks data-id="element-1822" />
      <FAQ data-id="element-1823" />
      <Reviews data-id="element-1824" />
      <CtaBanner data-id="element-1825" />
    </main>;
}